class Region {
  constructor(attributes) {
    this.code = attributes.code
    this.name = attributes.name
  }
}

export default Region
